import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {ApiService} from "../../service/api";

import {countries} from "../../data/countries";
import {FormBuilder, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {CartService} from "../../service/cart";
import swal from "sweetalert2";

export interface Registration {
    firstname: string;
    lastname: string;
    email: string;
    password: string;
    salutation: string;
    street: string;
    streetnumber: string;
    city: string;
    zip: string;
    country: string;
}

@Component({
    selector: 'fw-register',
    templateUrl: './register.html',
    encapsulation: ViewEncapsulation.None
})
export class RegisterComponent implements OnInit {
    public countries: any[] = countries;

    public registration: FormGroup;

    constructor(public apiService: ApiService, public fb: FormBuilder, public nav: Router, public cart: CartService) {
    }

    ngOnInit() {
        this.registration = this.fb.group({
            salutation: ['Herr', [Validators.required]],
            firstname: ['', [Validators.required]],
            lastname: ['', [Validators.required]],
            email: ['', [Validators.required, Validators.email]],
            email_repeat: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.minLength(6)]],
            password_repeat: ['', [Validators.required, Validators.minLength(6)]],
            street: ['', [Validators.required]],
            streetnumber: ['', [Validators.required]],
            city: ['', [Validators.required]],
            zip: ['', [Validators.required]],
            country: ['AT', [Validators.required]]
        }, {
            validator: this.matching([
                {original: 'password', compare: 'password_repeat'},
                {original: 'email', compare: 'email_repeat'}
            ])
        })
    }

    matching(controls: any[]): ValidatorFn {
        return (group: FormGroup) => {
            controls.forEach((config) => {
                const original = config.original, compare = config.compare;
                let passwordInput = group.controls[original];
                let passwordConfirmationInput = group.controls[compare];
                if (passwordInput.value !== passwordConfirmationInput.value) {
                    passwordConfirmationInput.markAsTouched();
                    passwordConfirmationInput.markAsDirty();
                    return passwordConfirmationInput.setErrors({notEquivalent: true})
                } else {
                    return passwordConfirmationInput.setErrors(null);
                }
            })

            return null;
        }
    }

    register($event) {
        this.apiService.call('/contact/index/register', this.registration.getRawValue()).then((result) => {
            this.registration.reset({
                salutation: 'Herr',
                country: 'AT'
            });

            swal({
                title: 'Erfolgreich',
                text: 'Die Registrierung war erfolgreich. Bitte prüfen Sie Ihre Mails um die Registrierung abzuschließen!',
                type: 'success'
            })

            this.nav.navigate(['/home']);
        }).catch((result) => {
            let message = JSON.parse(result.statusText);
            swal({
                title: message.title,
                text: message.message,
                type: 'warning'
            })
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/register/register.ts